<template>
  <div style="overflow:hidden !important;">

    <HeaderHelp></HeaderHelp>
    <section class="closefriend-hero ">
      <div class="container mt-5">
        <div class="row">
          <div class="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-lg-6 offset-lg-3 col-xl-6 offset-xl-3">
            <div class="custom-card">
              <div class="py-4">
                <h2>Set Your Price</h2>
              </div>
              <div class="custom-body">
                <div class="form-group">
                  <label for="number" class="font-grey">Monthly Price (USD)
                    <span class="danger ml-2" v-if="isRequired('monthlyPrice')">This is required field</span>
                  </label>
                  <input type="number" min="0" class="form-control selected-field"
                  onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                         name="monthlyPrice" value="50" v-model="user.monthlyPrice"
                         @focusout="fillAnnualPrice()">
                </div>
                <div class="form-group">
                  <div class="d-block">
                    <label for="number1" class="font-grey">Annual price (USD)
<!--                      <span class="danger ml-2" v-if="isRequired('annuallyPrice')">This is required field</span>-->
                    </label>
                    <input type="number" min="0" class="form-control valid-field"
                    onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                           name="annuallyPrice"
                           v-model="user.annuallyPrice" readonly>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-lg-6 offset-lg-3 col-xl-6 offset-xl-3 position-bottom ">
            <div class="row justify-content-center mx-md-0 mx-1">
              <div class="col-md-12 col-12 px-1 ">
                <button type="button"
                        class="btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                        @click="next()">Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'
import HeaderHelp from "@/components/module/influencer/shared/HeaderHelp";
import {numeric, required} from "vuelidate/lib/validators";
import titleMixin from "../../../../mixin/title-mixin";

export default {
  name: 'SetPriceMobile',
  title: 'Subscription price',
  mixins: [titleMixin],
  components: {HeaderHelp},
  data() {
    return {
      user: {},
      isSubmitted: false
    }
  },
  validations: {
    user: {
      monthlyPrice: {required, numeric},
   /*   annuallyPrice: {required, numeric},*/
    }
  },
  created() {
    this.user = this.getUser();
  },
  methods: {
    ...mapActions(['setUser']),
    ...mapGetters(['getUser']),
    next() {

      this.isSubmitted = true;
      this.$v.$touch();
      console.log(this.$v);
      if (this.$v.$invalid) {
        return;
      }
      this.setUser(this.user);
      this.$router.push({name: 'YourLinkMobile'});
    },
    isRequired(attrib) {
      return this.isSubmitted && !this.$v.user[attrib].required;
    },
    fillAnnualPrice() {
      if (!isNaN(this.user.monthlyPrice)) {
        this.$set(this.user, 'annuallyPrice', this.user.monthlyPrice * 10);
      } else {
        this.$set(this.user, 'annuallyPrice', '');
        ;
      }
    }
  }
}
;
</script>

